import store from "@/store";
import { axiosSingleton } from "../plugins/axios";

export function getCampus() {
  return axiosSingleton
    .getInstance()
    .get(`https://enjambrec.ugto.mx/CatalogosUG/api/Generales/GetCampus`);
}

export function getDivisionesByIdCampus(idCampus) {
  return axiosSingleton
    .getInstance()
    .get(
      `https://enjambrec.ugto.mx/CatalogosUG/api/RecursosHumanos/GetDivisionesByIdCampus?idCampus=${idCampus}`
    );
}

export function getDepartamentoByIdDivision(idDivision) {
  return axiosSingleton
    .getInstance()
    .get(
      `https://enjambrec.ugto.mx/CatalogosUG/api/RecursosHumanos/GetDepartamentoByIdDivision?idDivision=${idDivision}`
    );
}

export function getRolesInstitucionales() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Catalogos/RolInstitucional`,
  });
}

export function postFormularioReporte(obj) {
  var formData = new FormData();

  formData.append("objFormulario", JSON.stringify(obj));

  try {
    if (obj.itemsAnexos.length > 0) {
      obj.itemsAnexos.forEach((item, index) => {
        if (item.file != null && item.file != undefined) {
          formData.append("fileAnexo_" + item.id, item.file);
        }
      });
    }
  } catch {}

  return axiosSingleton.getInstance()({
    method: "post",
    url: `/EpRegistro`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function postFormularioCita(obj) {
  var formData = new FormData();
  formData.append("objFormulario", JSON.stringify(obj));

  return axiosSingleton.getInstance()({
    method: "post",
    url: `/SolicitudCita`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
